// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"94846475","977":"959cc400"}[chunkId] + ".chunk.js";
};